import { render, staticRenderFns } from "./allcities.vue?vue&type=template&id=5ad38fda&scoped=true&"
import script from "./allcities.vue?vue&type=script&lang=js&"
export * from "./allcities.vue?vue&type=script&lang=js&"
import style0 from "./allcities.vue?vue&type=style&index=0&id=5ad38fda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad38fda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
